import module from 'empresa/module.js'
import template from './template.html'


export class EmpresaConfiguracionFacturacionDireccionesEditarComponent {
  actualizando = false
  empresaId
  indice
  onClose

  constructor (EmpresaConfiguracionFacturacionDireccion) {
    this.EmpresaConfiguracionFacturacionDireccionService = EmpresaConfiguracionFacturacionDireccion
  }

  $onInit () {
    this.promise = this.EmpresaConfiguracionFacturacionDireccionService.get(this.empresaId, this.indice)
      .then((response) => (this.data = response.data, this.min = this.data.timbrado_folio))
  }

  confirmacion (data) {
    this.actualizando = false

    if (!data.exito) return

    this.form.$setPristine()
  }

  cerrar () {
    this.onClose()
  }

  upperCase (string) {
    this.data.timbrado_serie = string.toUpperCase()
  }
}

module.component('empresaConfiguracionFacturacionDireccionesEditar', {
  controller: EmpresaConfiguracionFacturacionDireccionesEditarComponent,
  template,
  bindings: {
    empresaId: '<',
    indice: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/facturacion/direcciones/editar/component.js